module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('small', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.helpActivitiesResourceModal = true
      }
    }
  }, [_vm._v("關於事項分析？")])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 deal_page_sidebar_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.activity_categories), function(category) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      class: category.icon
    }), _vm._v(" " + _vm._s(category.title))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.countActivitiesNumber(category.id)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.countFinishedHour(category.id)))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("未分類")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.countActivitiesNumber(null)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.countFinishedHour(null)))])])], 2), _vm._v(" "), _c('h4', [_vm._v("總時數：" + _vm._s(_vm.totalHours()))]), _vm._v(" "), _c('small', {
    staticClass: "text-gray"
  }, [_vm._v("此處的總數只包含了有定義小時的事項，所以只標示日期的事項（沒有小時）沒有辦法列入計算～")])])])])])]), _vm._v(" "), (_vm.helpActivitiesResourceModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.helpActivitiesResourceModal = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper ",
    on: {
      "click": function($event) {
        _vm.helpActivitiesResourceModal = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-container modal-center col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.helpActivitiesResourceModal = false;
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _vm._m(3)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("事項分析")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("事項類型")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("數量")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("所用時數")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "header text-center"
    }
  }, [_c('div', {
    staticClass: "widget-header margin-bottom-0 clearfix"
  }, [_c('h4', [_vm._v("事項分析 也是資源管理")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body j-forms text-left"
  }, [_c('h5', [_vm._v("介紹：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("分析有關於此專案，或是此業務在這段時間內的所有"), _c('span', {
    staticClass: "text-info"
  }, [_vm._v("完成的")]), _vm._v("待辦事項。依照類別統計總數，以及所使用的時間")]), _vm._v(" "), _c('h5', [_vm._v("優點：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("事項分析就是資源管理！可以馬上了解此案件或業務，總共花在此專案上的時數。更快速的評估使用的時間資源，是否值得此專案，或是哪個環節出了問題，更方便於專案的管理")]), _vm._v(" "), _c('h5', [_vm._v("如何確實的呈現數據？")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("將所有待辦事項，都確實定義所用的時間（小時與分），Flowneat將會自動計算完成的事項所使用的時間，若只是圈出日期的代辦事項，將不會列入計算。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f41607a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/ActivitiesResource.vue
// module id = 703
// module chunks = 4